var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClearSky01 = function SvgClearSky01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 28,
    y1: 164.16,
    x2: 178.39,
    y2: 30.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -15,
    y1: 115.9,
    x2: 135.38,
    y2: -18.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -10.31,
    y1: 121.16,
    x2: 140.07,
    y2: -12.83,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 66.32,
    y1: 207.17,
    x2: 216.7,
    y2: 73.17,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 31.32,
    y1: 167.88,
    x2: 181.7,
    y2: 33.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 24.69,
    y1: 160.44,
    x2: 175.07,
    y2: 26.45,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -29.5,
    y1: 99.63,
    x2: 120.89,
    y2: -34.37,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 85.5,
    y1: 228.7,
    x2: 235.89,
    y2: 94.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 71.01,
    y1: 212.43,
    x2: 221.39,
    y2: 78.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 5.94,
    y1: 139.4,
    x2: 156.33,
    y2: 5.41,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M100.39,39.06c-33.47,0-60.61,27.13-60.61,60.61s27.13,60.61,60.61,60.61,60.61-27.14,60.61-60.61-27.13-60.61-60.61-60.61ZM100.39,150.75c-28.21,0-51.08-22.87-51.08-51.08s22.87-51.08,51.08-51.08,51.08,22.87,51.08,51.08-22.87,51.08-51.08,51.08Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.39,26.51c2.63,0,4.76-2.13,4.76-4.76V4.43c0-2.63-2.13-4.76-4.76-4.76s-4.76,2.13-4.76,4.76v17.32c0,2.63,2.13,4.76,4.76,4.76Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M22.47,94.9H5.15c-2.63,0-4.76,2.13-4.76,4.76s2.13,4.76,4.76,4.76h17.32c2.63,0,4.76-2.13,4.76-4.76s-2.13-4.76-4.76-4.76Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M195.63,94.9h-17.32c-2.63,0-4.76,2.13-4.76,4.76s2.13,4.76,4.76,4.76h17.32c2.63,0,4.76-2.13,4.76-4.76s-2.13-4.76-4.76-4.76Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M45.29,150c-1.22,0-2.44.46-3.37,1.39l-12.24,12.24c-1.86,1.86-1.86,4.87,0,6.73,1.86,1.86,4.87,1.86,6.73,0l12.24-12.24c1.86-1.86,1.86-4.88,0-6.74-.93-.93-2.15-1.39-3.37-1.39Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M167.73,27.56c-1.22,0-2.44.47-3.37,1.4l-12.24,12.24c-1.86,1.86-1.86,4.88,0,6.73,1.86,1.86,4.87,1.86,6.73,0l12.24-12.24c1.86-1.86,1.86-4.88,0-6.73-.93-.93-2.15-1.4-3.37-1.4Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M41.92,47.93c1.86,1.86,4.88,1.86,6.74,0s1.86-4.88,0-6.73l-12.24-12.24c-.93-.93-2.15-1.4-3.37-1.4s-2.44.47-3.37,1.4c-1.86,1.86-1.86,4.88,0,6.73l12.24,12.24Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M158.86,151.4c-.93-.93-2.15-1.39-3.37-1.39s-2.44.46-3.37,1.39c-1.86,1.86-1.86,4.88,0,6.74l12.24,12.24c1.86,1.86,4.88,1.86,6.73,0,1.86-1.86,1.86-4.87,0-6.73l-12.24-12.24Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M100.39,172.83c-2.63,0-4.76,2.13-4.76,4.76v17.32c0,2.63,2.13,4.76,4.76,4.76s4.76-2.13,4.76-4.76v-17.32c0-2.63-2.13-4.76-4.76-4.76Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.26,61.57c-.99,0-2,.31-2.85.95l-2.13,1.6c-8.7,6.52-15.15,15.59-18.46,25.94l-1.05,3.28c-.8,2.51.58,5.18,3.09,5.99,2.5.8,5.18-.58,5.99-3.08l1.05-3.28c2.71-8.47,7.99-15.89,15.1-21.22l2.13-1.6c2.1-1.58,2.53-4.56.95-6.67-.94-1.25-2.37-1.9-3.81-1.9Z"
  })));
};
export default SvgClearSky01;